import React from 'react'
import MappingSelect from '../../Shared/Components/MappingSelect'
import MappingCheckbox from '../../Shared/Components/MappingCheckbox'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../multiLocation.module.css'

const MultiLocationRow = ({ row, erpLocations, ecommerceLocations, isDisabled, onChange, onRemove }) => (
    <li className={[Shared.row, row.isNew ? Shared.rowNew : ''].join(' ').trim()}>
        <div className={`${Shared.grid} ${Style.grid}`}>
            <MappingSelect
                inputId={`erpLocation-${row.rowId}`}
                options={erpLocations}
                value={row.erpLocationId}
                fallbackLabel={row.erpMethod}
                placeholder="Select ERP Method"
                customLabel="Custom ERP Method"
                customPlaceholder="Enter ERP method"
                hasError={row.erpLocationId === ''}
                isDisabled={isDisabled}
                onChange={(value, option) => onChange(row.rowId, {
                    erpLocationId: value,
                    erpMethod: option ? option.label : value
                })}
            />
            <span className={Shared.arrow} aria-hidden="true">&rarr;</span>
            <MappingSelect
                inputId={`ecommerceLocation-${row.rowId}`}
                options={ecommerceLocations}
                value={row.ecommerceLocationId}
                fallbackLabel={row.ecommerceMethod}
                placeholder="Select eCommerce Method"
                customLabel="Custom eCommerce Method"
                customPlaceholder="Enter eCommerce method"
                hasError={row.ecommerceLocationId === ''}
                isDisabled={isDisabled}
                onChange={(value, option) => onChange(row.rowId, {
                    ecommerceLocationId: value,
                    ecommerceMethod: option ? option.label : value
                })}
            />
            <MappingCheckbox
                inputId={`locationIsDefault-${row.rowId}`}
                label="Is Default ?"
                checked={row.isDefault}
                isDisabled={isDisabled}
                onChange={(checked) => onChange(row.rowId, { isDefault: checked })}
            />
            <button
                type="button"
                className={Shared.deleteButton}
                title="Remove mapping"
                aria-label={`Remove mapping for ${row.erpMethod || 'this row'}`}
                disabled={isDisabled}
                onClick={() => onRemove(row.rowId)}
            >
                <i className="uil-trash-alt" aria-hidden="true" />
            </button>
        </div>
        {row.isNew ? <span className={Shared.newBadge}>Not saved yet</span> : null}
    </li>
)

export default React.memo(MultiLocationRow)
